/**
 * @generated SignedSource<<f1d3806707831744935decf641a9c80e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type EventMemberControl = "HIDDEN" | "SELECTABLE" | "VISIBLE";
import { FragmentRefs } from "relay-runtime";
export type EventDetailActions_event$data = {
  readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
  readonly clientEligibleSignUpWindows: ReadonlyArray<{
    readonly cancelDeadlineAt: string | null | undefined;
    readonly cancelDeadlineDaysAhead: number | null | undefined;
    readonly cancelDeadlineTime: string | null | undefined;
    readonly charges: {
      readonly edges: ReadonlyArray<{
        readonly memberControl: EventMemberControl;
        readonly node: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly closeDaysAhead: number | null | undefined;
    readonly closeTime: string | null | undefined;
    readonly closesAt: string | null | undefined;
    readonly openTime: string | null | undefined;
    readonly opensAt: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly eventSeries: {
    readonly facility: {
      readonly id: string;
    };
    readonly name: string;
  };
  readonly id: string;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly unknownGuestsAllowed: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentSignUp_event">;
  readonly " $fragmentType": "EventDetailActions_event";
};
export type EventDetailActions_event$key = {
  readonly " $data"?: EventDetailActions_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailActions_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailActions_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "accessStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unknownGuestsAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closeDaysAhead",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closeTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closesAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "opensAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineDaysAhead",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindowChargesConnection",
          "kind": "LinkedField",
          "name": "charges",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUpWindowChargesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberControl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationChargeType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentSignUp_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "f5369a7465ace5741d255d1e6513e97e";

export default node;
